<section class="section-depoimentos" id="depoimentos">

  <!-- ── Cabeçalho ── -->
  <div class="depoimentos-header">
    <div class="depoimentos-label anim">
      <!-- <h4>breakers</h4> -->
      <span class="depoimentos-eyebrow">Comentários</span>
    </div>
    <h2 class="depoimentos-title anim anim--delay-1">O que estão Dizendo de Breakers</h2>
    <div class="depoimentos-divider anim anim--delay-2"></div>
    <p class="depoimentos-subtitle anim anim--delay-3">
      Mais de dez vozes. Uma só conclusão.
    </p>
  </div>

  <!-- ── Destaque: primeiro depoimento ── -->
  <div class="depoimentos-featured anim anim--delay-2">
    <span class="featured-quote-mark" aria-hidden="true">"</span>
    <blockquote class="featured-text">
      {{ testimonials[0].text }}
    </blockquote>
    <div class="featured-author">
      <div
        class="featured-avatar"
        [style.backgroundImage]="'url(' + testimonials[0].picture + ')'"
        [style.backgroundPosition]="testimonials[0].bgPosition"
        role="img"
        [attr.aria-label]="'Foto de ' + testimonials[0].handle"
      ></div>
      <div class="featured-author-info">
        <a
          [href]="testimonials[0].link"
          target="_blank"
          rel="noopener noreferrer"
          class="author-handle"
        >{{ testimonials[0].handle }}</a>
        <span class="author-source">Instagram</span>
      </div>
    </div>
  </div>

  <!-- ── Carousel dos demais depoimentos ── -->
  <div class="depoimentos-carousel-wrapper anim anim--delay-3">
    <p-carousel
      styleClass="depoimentos-carousel"
      [value]="testimonials.slice(1)"
      [numVisible]="3"
      [numScroll]="1"
      [circular]="true"
      [autoplayInterval]="4500"
      [showIndicators]="false"
      [responsiveOptions]="responsiveOptions"
    >
      <ng-template let-item pTemplate="item">
        <div class="depoimento-card">
          <span class="card-quote-mark" aria-hidden="true">"</span>
          <p class="card-text">{{ item.text }}</p>
          <div class="card-author">
            <div
              class="card-avatar"
              [style.backgroundImage]="'url(' + item.picture + ')'"
              [style.backgroundPosition]="item.bgPosition"
              role="img"
              [attr.aria-label]="'Foto de ' + item.handle"
            ></div>
            <div class="card-author-info">
              <a
                [href]="item.link"
                target="_blank"
                rel="noopener noreferrer"
                class="author-handle"
              >{{ item.handle }}</a>
              <span class="author-source">{{ item.source === 'amazon' ? 'Amazon' : 'Instagram' }}</span>
            </div>
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </div>

</section>
